import { msalInstance, tokenRequest } from '../authConfig';
import { SKIP_AUTH, USE_LOGGER } from '../config/constants';

export async function fetchWithAuth(url, options = {}) {
  // Skip auth for localhost in development if configured
  if (SKIP_AUTH) {
    if (USE_LOGGER) {
      console.log('Skipping auth for development environment');
    }
    return fetch(url, options);
  }

  try {
    const account = msalInstance.getActiveAccount() || (msalInstance.getAllAccounts()[0] || null);
    let token = null;

    if (account) {
      const response = await msalInstance.acquireTokenSilent({
        ...tokenRequest,
        account
      });
      token = response.accessToken;
    }


    const headers = {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(account ? { GID: account.idTokenClaims.SCGID } : {}),
    };

    // Force HTTP/1.1 for streaming requests to avoid HTTP/2 protocol errors
    const fetchOptions = { ...options, headers };
    if (options.method === 'POST' && url.includes('chat-retrieval')) {
      fetchOptions.signal = new AbortController().signal;
      // Add a custom header to hint at HTTP/1.1 preference
      const hasAccept = Object.keys(fetchOptions.headers || {}).some(
        (h) => h.toLowerCase() === 'accept'
      );
      fetchOptions.headers = {
        ...fetchOptions.headers,
        'Connection': 'keep-alive',
        ...(hasAccept ? {} : { 'Accept': 'text/plain, application/json' }),
      };
    }

    return fetch(url, fetchOptions);

  } catch (err) {
    if (USE_LOGGER) {
      console.error('Error in fetchWithAuth:', err);
    }
    // Fallback to regular fetch if auth fails
    return fetch(url, options);
  }
} 